<div *ngIf="_tabOpen">
    <ng-container *secureStructural="security">
        <ng-content></ng-content>
    </ng-container>
</div>